import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import FrontUserExpressInfo from '../entities/font-expressinfo'
import appconst from '@/lib/appconst';


interface FrontUserExpressInfoState extends ListState<FrontUserExpressInfo> {
    UserExpressInfo: FrontUserExpressInfo,
}

class FrontUserExpressInfoMutations extends ListMutations<FrontUserExpressInfo>{

}
class FontExpressUser extends ListModule<FrontUserExpressInfoState, any, FrontUserExpressInfo>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<FrontUserExpressInfo>(),
        loading: false,
        UserExpressInfo: FrontUserExpressInfo,


    }
    actions = {
        async getAll(context: ActionContext<FrontUserExpressInfoState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/UserExpressInfo/GetUserExpressInfoList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<FrontUserExpressInfo>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        } ,
        async updateremark(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/UserExpressInfo/Edit', payload.data);
        },
        async editReturn(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/UserExpressInfo/EditReturn', payload.data);
        }
    };
    mutations = {
        setCurrentPage(state: FrontUserExpressInfoState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FrontUserExpressInfoState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getImgUrl(state: FrontUserExpressInfoState, data: any) {
            if (data.imageGuid && data.imageGuid.length > 1) {
                data.url = appconst.remoteServiceBaseUrl + "api/File/GetUserUploadImage?guid=" + data.imageGuid;
            } else {
                data.url = null;
            }
        },
        getGoodsImgUrl(state: FrontUserExpressInfoState, datas: any) {
            if (datas.goodsImageGuid && datas.goodsImageGuid.length > 1) {
                datas.urls = appconst.remoteServiceBaseUrl + "api/File/GetLogisticsImage?guid=" + datas.goodsImageGuid;
            } else {
                datas.urls = null;
            }
        }
    }
}

const fontExpressUser = new FontExpressUser();
export default fontExpressUser;